import React from 'react';

const SortArrowUp = () => (
    <React.Fragment>
        <g transform="translate(24 24) rotate(180)">
            <path fill="none" d="M0,0H24V24H0Z"/>
            <path d="M7,10l5,5,5-5Z"/>
        </g>
    </React.Fragment>
);

export default SortArrowUp;
